/**
 * Renders a small percentage bar chart where each bar is filled by height (precise).
 * Use on a container with data-percentage-bar-chart and data-percentage (0–100).
 *
 * @example
 * <div data-percentage-bar-chart data-percentage="25.7" data-bars="10"></div>
 */
const DEFAULT_BARS = 10;

function getBarFillPercent(percentage, barIndex, totalBars) {
  const segmentSize = 100 / totalBars;
  const segmentStart = barIndex * segmentSize;
  const segmentEnd = (barIndex + 1) * segmentSize;

  if (percentage <= segmentStart) return 0;
  if (percentage >= segmentEnd) return 100;
  return ((percentage - segmentStart) / segmentSize) * 100;
}

function renderPercentageBarChart(container) {
  const percentage = Number(container.dataset.percentage) || 0;
  const bars = Number(container.dataset.bars) || DEFAULT_BARS;

  container.classList.add('flex', 'items-end', 'gap-0.5', 'h-6');
  container.innerHTML = '';

  for (let i = 0; i < bars; i++) {
    const fillPercent = getBarFillPercent(percentage, i, bars);
    const barEl = document.createElement('div');
    barEl.className = 'w-1.5 h-6 flex flex-col justify-end rounded-sm overflow-hidden shrink-0';

    const trackEl = document.createElement('div');
    trackEl.className = 'w-full h-full flex flex-col justify-end rounded-sm bg-gray-100 dark:bg-gray-900';

    const fillEl = document.createElement('div');
    fillEl.className = 'w-full rounded-sm bg-primary-500 dark:bg-primary-500 shrink-0';
    fillEl.style.height = `${fillPercent}%`;
    if (fillPercent > 0 && fillPercent < 100) fillEl.style.minHeight = '2px';

    trackEl.appendChild(fillEl);
    barEl.appendChild(trackEl);
    container.appendChild(barEl);
  }
}

function init() {
  document.querySelectorAll('[data-percentage-bar-chart]').forEach(renderPercentageBarChart);
}

export function initPercentageBarCharts() {
  init();
  document.addEventListener('livewire:navigated', init);
}
